import { render } from "./CompanyDetails.vue?vue&type=template&id=dc4d60c0&scoped=true"
import script from "./CompanyDetails.vue?vue&type=script&lang=js"
export * from "./CompanyDetails.vue?vue&type=script&lang=js"

import "./CompanyDetails.vue?vue&type=style&index=0&id=dc4d60c0&scoped=true&lang=css"

import exportComponent from "/home/helder/SDD_2/Projetos/goldylocks-central-ui-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc4d60c0"]])

export default __exports__